import { useLoadPublicPageDetailQuery } from "@features/publicPage/page/api";
import React from "react";

const StaticContentDiv = ({ content_key }) => {
  // load content;
  const { data: staticContentData } = useLoadPublicPageDetailQuery(
    content_key,
    {
      skip: !content_key,
      refetchOnMountOrArgChange: true,
    }
  );

  if (staticContentData?.data?.description) {
    return (
      <p
        className='staticContentDiv'
        dangerouslySetInnerHTML={{
          __html: staticContentData.data.description,
        }}
      />
    );
  }

  return <></>;
};

export default StaticContentDiv;
